import type { AppNotifEvent } from '@/features/application/app-events/types'

export const PLACEHOLDER_PRENOM = 'Ex : Jean' as const
export const PLACEHOLDER_NOM = 'Ex : Dupont' as const
export const PLACEHOLDER_NOM_NAIS = 'Ex : Durand' as const
export const PLACEHOLDER_DATE_NAIS = 'Ex : 01/01/1990' as const
export const PLACEHOLDER_EMPLOI_TUTEUR = 'Ex : Ingénieur' as const
export const PLACEHOLDER_DIPLOME_PREPARE = "Ex : Diplôme d'ingénieur" as const
export const PLACEHOLDER_ADR_VOIE = 'Ex : 10 impasse GRANET' as const
export const PLACEHOLDER_ADR_COMPLEMENT = 'Ex : Bâtiment B' as const
export const PLACEHOLDER_ADR_CP = 'Ex : 75001' as const
export const PLACEHOLDER_ADR_VILLE = 'Ex : Paris' as const
export const PLACEHOLDER_EMAIL = 'Ex: nom.prenom@email.fr' as const
export const PLACEHOLDER_TEL = 'Ex : 01 23 45 67 89' as const
export const PLACEHOLDER_DATE = 'Ex : 01/01/2024' as const
export const PLACEHOLDER_DUREE = 'Ex : 35h00'
export const PLACEHOLDER_MONTANT = 'Ex: 800,00' as const
export const PLACEHOLDER_MONTANT_HORAIRE = 'Ex: 14,00' as const
export const HINT_DATE = 'Format: JJ/MM/AAAA'
export const HINT_DUREE = 'Format: XX:XX ou XXhXX'
export const HINT_SIREN_SIRET_OF = "Siren ou Siret de l'organisme"
export const PLACE_HOLDER_SIREN = 'Ex : 123456789'
export const LABEL_NUMERO_VOIE = 'N° et voie'
export const LABEL_MONTANT_DEMANDE_HT = 'Montant demandé HT'
export const MSG_INFO_FSE =
  "Les demandes FSE sont traitées par ordre d'arrivée, sous réserve de complétude, et dans la limite des fonds octroyés par l'Etat. Au regard des dossiers déjà validés et en cours d'instruction par nos services, les dépôts sont clos pour le FSE 2025."

export const NOTIF_SAISIE_SALARIE_MODIFIÉE: AppNotifEvent = {
  name: 'AppNotif',
  arg: {
    message: 'La modification du salarié a entrainé la réinitialisation du NIR',
    titre: 'Saisie modifiée',
    type: 'success',
  },
}
